import { useState } from 'react';
import { useAddNetworkCIDR } from '../NetworkForm.queries.ts';

type Options = {
  networkId: `network-${string}` | null;
  existingCidrV4: string | undefined;
};

/**
 * Adds an IPv4 CIDR to an existing IPv6-only network as part of a larger edit flow. Once a
 * POST has succeeded on this mount, `lockedCidrV4` returns the posted value so the caller
 * can render the IPv4 Field readonly — on a partial-failure retry the user therefore cannot
 * change the value out from under the already-committed backend state. Inspired by
 * useCreatableRole / hasCreatedRole in the host/relay/lighthouse forms.
 */
export function useAddableCidrV4({ networkId, existingCidrV4 }: Options) {
  const [postedCidrV4, setPostedCidrV4] = useState<string | null>(null);
  const mutation = useAddNetworkCIDR();

  const addCidrIfNeeded = async (cidrV4: string | undefined) => {
    if (!networkId || existingCidrV4 || !cidrV4 || cidrV4 === postedCidrV4) {
      return;
    }
    await mutation.mutateAsync({ id: networkId, cidr: cidrV4 });
    setPostedCidrV4(cidrV4);
  };

  return { addCidrIfNeeded, lockedCidrV4: existingCidrV4 ?? postedCidrV4 };
}
